const mixed = [
    {
        name: "CULTURE",
        idea: "Sprich 5 Minuten lang mit einem falschen Akzent",
        freq: 3,
        bg: "#CE93D8",
        text: "#222",
    },
    {
        name: "TODO",
        idea: "Trinke einen Shot",
        freq: 3,
        bg: "#FFF59D",
        text: "#222",

    },
    {
        name: "DANCE",
        idea: "Tanze 30 Sekunden lang ohne Musik.",
        freq: 3,
        bg: "#F48FB1",
        text: "#222",

    },
    {
        name: "MAGIC",
        idea: "Versuche einen Zaubertrick.",
        freq: 3,
        bg: "#ef9a9a",
        text: "#222",

    },
    {
        name: "BANANA",
        idea: "Sage nach allem, was du sagst, 'Banane', bis zum nächsten Zug.",
        freq: 3,
        bg: "#FFCC80",
        text: "#222",

    },
    {
        name: "BEARD️",
        idea: "Zeichne mit einem abwaschbaren Marker einen Schnurrbart auf dein Gesicht.",
        freq: 3,
        bg: "#80CBC4",
        text: "#222",

    },
    {
        name: "LOVE",
        idea: "Sprich mit einem unbelebten Gegenstand, als wäre es dein Schwarm.",
        freq: 3,
        bg: "#FFCC80",
        text: "#222",

    },
    {
        name: "PIRATE",
        idea: "Einbeiniger Pirat: Hüpfe auf einem Bein und schreie Piratensachen.",
        freq: 3,
        bg: "#333",
        text: "#eee",

    },
    {
        name: "FREEZE",
        idea: "Statue einfrieren: Friere wie eine Statue ein, wenn jemand 'Statue' sagt.",
        freq: 3,
        bg: "#CE93D8",
        text: "#222",

    },
    {
        name: "STORY",
        idea: "Erzähle eine Geschichte in nur 5 Worten.",
        freq: 3,
        bg: "#FFF59D",
        text: "#222",

    },
    {
        name: "LOSE A TURN 🔄",
        idea: "Verliere eine Runde.",
        freq: 3,
        bg: "white",
        text: "#222",

    },
    {
        name: "AGAIN",
        idea: "Trinke einen Schluck und drehe nochmal.",
        freq: 3,
        bg: "#ef9a9a",
        text: "#222",

    },
    {
        name: "GIVE3",
        idea: "Gebe 3 Schlucke aus.",
        freq: 3,
        bg: "#CE93D8",
        text: "#222",

    },
    {
        name: "GIVE2",
        idea: "Gebe 2 Schlucke aus.",
        freq: 3,
        bg: "#F48FB1",
        text: "#222",

    },
    {
        name: "GIRLS",
        idea: "Mädchen trinken.",
        freq: 3,
        bg: "#80CBC4",
        text: "#222",

    },
    {
        name: "BOYS",
        idea: "Jungs trinken.",
        freq: 3,
        bg: "#FFCC80",
        text: "#222",

    },
    {
        name: "KISS L",
        idea: "Küsse die Person rechts von dir.",
        freq: 3,
        bg: "#CE93D8",
        text: "#222",

    },
    {
        name: "KISS R",
        idea: "Küsse die Person links von dir.",
        freq: 3,
        bg: "#81D4FA",
        text: "#222",

    },
    {
        name: "SLAP",
        idea: "Klaps auf den Hintern links.",
        freq: 3,
        bg: "#FFF59D",
        text: "#222",

    },
    {
        name: "QUESTIONMASTER",
        idea: "Frage-Meister, niemand sollte deine Fragen beantworten.",
        freq: 1,
        bg: "#333",
        text: "#eee",
        fontMod: 2,
    },
    {
        name: "DRAMA",
        idea: "Mache einen dramatischen Abgang und Eintritt.",
        freq: 1,
        bg: "#FFD54F",
        text: "#222",
        fontMod: 2,
    },
]

export default mixed;
